import { Component, inject } from '@angular/core';

import { ThemeService } from './theme.service.js';

/**
 * Compact sun/moon toggle for the header. Flips between light and dark
 * regardless of whether the user was on `'system'` — that matches the
 * single-button-in-the-toolbar UX and avoids a tri-state widget for
 * casual users (the full 3-way picker lives in ThemeSelectorComponent).
 */
@Component({
  selector: 'es-theme-toggle',
  template: `
    <button
      type="button"
      class="inline-flex items-center justify-center w-8 h-8 rounded-md cursor-pointer text-[var(--text-secondary)] hover:text-[var(--text)] hover:bg-[var(--bg-card-hover)] transition-colors"
      [attr.aria-label]="theme.isDark() ? 'Switch to light theme' : 'Switch to dark theme'"
      (click)="theme.toggle()"
    >
      <span aria-hidden="true">{{ theme.isDark() ? '☀' : '☾' }}</span>
    </button>
  `,
})
export class ThemeToggleComponent {
  readonly theme = inject(ThemeService);
}
